var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { CheckTwoFaOnLoginView } from './check-two-fa-on-login';
import { useTempUserGuard } from './hooks/use-temp-user-guard';
import { useTempUserFlagsContextSwitcher } from './hooks/use-temp-user-flags-context-switcher';
import { useNavigate } from '../../../../infra/routing';
import { getErrorMessage, getMaskedContact, isVerificationAvailable } from './utils';
import { getLoginRedirectObject, getTemporaryTwoFaUser, getTwoFaReturnLoginUrl, resetTemporaryTwoFaUser, } from './store';
import { useTwoFaCheckHandlers } from './hooks/use-two-fa-check-handlers';
import { useTwoFaCheckTimeout } from './hooks/use-two-fa-check-timeout';
import { handleVerifyCode } from './actions/handle-verify-code';
import { codeExpiredErrorMessageKey, accountLockedErrorMessageKey } from './constants';
import { useOtpInputHandlers } from '../hooks/use-otp-input';
import { setReturnToLoginError, setLockedAccountUsername } from '../../login/store';
import { LockedAccountModal } from '../components/locked-account-modal';
import { t } from '../../../../infra/i18n';
export var CheckTwoFaOnLoginContainer = function () {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var redirectObject = useSelector(getLoginRedirectObject);
    var loginUrl = useSelector(getTwoFaReturnLoginUrl);
    var _a = useOtpInputHandlers(), code = _a.code, setCode = _a.setCode, status = _a.status, setStatus = _a.setStatus, resetOtpInput = _a.reset;
    var flagsContextSwitcher = useTempUserFlagsContextSwitcher();
    var shouldPerformSecondFactorCheck = useTempUserGuard(flagsContextSwitcher);
    var tempUser = useSelector(getTemporaryTwoFaUser);
    var isSmsVerificationAvailable = isVerificationAvailable(tempUser, 'sms');
    var isEmailVerificationAvailable = isVerificationAvailable(tempUser, 'email');
    var _b = useState(isSmsVerificationAvailable ? 'phone' : 'email'), verificationType = _b[0], setVerificationType = _b[1];
    var _c = useState(false), isLockedOut = _c[0], setIsLockedOut = _c[1];
    var _d = useState([]), sentVerificationMethods = _d[0], setSentVerificationMethods = _d[1];
    var _e = useTwoFaCheckHandlers(), sendVerificationCode = _e.sendVerificationCode, validateCode = _e.validateCode, resetVerification = _e.reset;
    useEffect(function () {
        if (shouldPerformSecondFactorCheck) {
            sendVerificationCode(verificationType);
            setSentVerificationMethods(function (prev) { return __spreadArray(__spreadArray([], prev, true), [verificationType], false); });
        }
    }, [shouldPerformSecondFactorCheck]);
    var reset = function () {
        resetVerification();
        resetOtpInput();
    };
    var returnToLogin = function (errorMessage) {
        reset();
        flagsContextSwitcher.switchTempUserLdContext(null);
        dispatch(resetTemporaryTwoFaUser());
        dispatch(setReturnToLoginError(errorMessage));
        if (isLockedOut && (tempUser === null || tempUser === void 0 ? void 0 : tempUser.username)) {
            dispatch(setLockedAccountUsername(tempUser.username));
        }
        else {
            dispatch(setLockedAccountUsername(null));
        }
        navigate(loginUrl);
    };
    useTwoFaCheckTimeout({
        onTempUserTokenExpired: function () { return returnToLogin(t(codeExpiredErrorMessageKey)); },
    });
    var handleResendCode = function () {
        reset();
        sendVerificationCode(verificationType);
    };
    var handleBack = function () {
        returnToLogin();
    };
    var handleSwitchVerificationType = function () {
        reset();
        setVerificationType(function (prevType) {
            var newType = prevType === 'phone' ? 'email' : 'phone';
            if (!sentVerificationMethods.includes(newType)) {
                sendVerificationCode(newType);
                setSentVerificationMethods(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newType], false); });
            }
            return newType;
        });
    };
    var handleSubmit = function (submittedCode) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleVerifyCode({
                        setStatus: setStatus,
                        setIsLockedOut: setIsLockedOut,
                        validateCode: validateCode,
                        verificationType: verificationType,
                        code: submittedCode,
                        redirectObject: redirectObject,
                        dispatch: dispatch,
                        navigate: navigate,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLockedModalClose = function () {
        returnToLogin(t(accountLockedErrorMessageKey));
    };
    if (!shouldPerformSecondFactorCheck) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(CheckTwoFaOnLoginView, { phone: getMaskedContact(tempUser, 'sms'), email: getMaskedContact(tempUser, 'email'), twoFaVerificationMethod: verificationType, code: code, setCode: setCode, status: status, errorMessage: getErrorMessage(status, isLockedOut), onResendCode: handleResendCode, onSubmit: handleSubmit, onBack: handleBack, isLockedOut: isLockedOut, onSwitchTwoFaMethod: handleSwitchVerificationType, canSwitchTwoFaMethod: isSmsVerificationAvailable && isEmailVerificationAvailable }), _jsx(LockedAccountModal, { open: isLockedOut, onClose: handleLockedModalClose })] }));
};
